<template>
  <header :class="{active: menuIsShown}">
    <div class="decor"></div>
    <router-link :to="{ name: 'home' }" title="Globulo Quest" class="logo"><img src="@/assets/images/globulo-quest.png" alt="Globulo Quest Logo" title="Globulo Quest"/></router-link>

    <div class="user-infos">
      <router-link :to="{name: 'notifications'}" class="user-notifs" ><i class="fas fa-bell"></i>
        <span v-if="unseenNotificationsCount !== 0" >
          <template>{{ unseenNotificationsCount }}</template>
        </span>
      </router-link>
      <template v-if="me.account_type === 'caregiver'">
        <router-link :to="{ name: 'edit_account_caregiver' }" title="Editez son avatar">
          <div class="user-avatar caregiver">
            <caregiver-avatar :user="me" />
          </div>
        </router-link>
      </template>
      <template v-else>
        <router-link :to="{ name: 'EditAvatar' }" title="Editez son avatar">
          <div class="user-avatar">
            <avatar :recipe="me.avatar" />
          </div>
        </router-link>
      </template>
      <p><span>Bonjour</br> {{ completeName }}</span>
      <a class="logout" @click="signout">Se déconnecter</a>
      </p>
    </div>

    <div class="bt-mobile" @click="showMenu"></div>
    <nav class="main-menu" >
      <ul>
        <li class="close-menu" @click="showMenu"><i class="fas fa-times"></i>Fermer le menu</li>
        <li class="home"><router-link :to="{ name: 'home' }" title="" class="button">Accueil</router-link></li>
        <li><slimy-button href="concept">Le Concept Globulo Quest</slimy-button></li>

        <li class="membre">
          <slimy-button type-bt="blue" :href="`dashboard-${me.account_type}`">Carnet de bord</slimy-button>
        </li>

        <li><slimy-button type-bt="red" href="fil_rouge">Jeu fil rouge</slimy-button></li>

        <if-user can="play_games">
          <li><slimy-button type-bt="yellow" href="games">Mini jeux</slimy-button></li>
        </if-user>
        <if-user can="read_documents">
          <li><slimy-button type-bt="blue" href="fiches_medicales">Bibliothèque</slimy-button></li>
        </if-user>
        <li class="close-menu logout"><a @click="signout">Se déconnecter</a></li>
      </ul>
    </nav>
    <transition name="modal">
      <modal-badge class="modal-badge" v-if="modalBadgeIsShown" @close="closeModalBadge"></modal-badge>
    </transition>
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapState } from 'vuex'

  import Bouton from '@/components/Bouton.vue';
  import SlimyButton from '@/components/SlimyButton.vue';
  import ModalFilrouge from '@/components/modals/Filrouge.vue';
  import ModalLogin from '@/components/modals/Login.vue';
  import ModalBadge from '@/components/modals/Badge.vue';
  import Avatar from '@/components/Avatar';
  import CaregiverAvatar from '@/components/CaregiverAvatar';
  import IfUser from '@/components/IfUser'

  export default {
    components: { Bouton, SlimyButton, ModalLogin, ModalFilrouge, Avatar, CaregiverAvatar, IfUser, ModalBadge },
    data () {
      return {
       modalIsShown: false,
       modalRedIsShown: false,
       menuIsShown: false
      }
    },
    computed: {
      ...mapGetters(['completeName']),
      ...mapState(['me', 'unseenNotificationsCount', 'unseenBadges']),
      ...mapActions(['resetNotificationsCount']),
      modalBadgeIsShown() {
        return this.unseenBadges.length
      }
    },
    methods: {
      showModal () {
        this.modalIsShown = true;
      },
      closeModal () {
        this.modalIsShown = false;
      },
      showModalRed () {
        this.modalRedIsShown = true;
      },
      closeModalRed () {
        this.modalRedIsShown = false;
      },
      showMenu () {
        this.menuIsShown = !this.menuIsShown;
      },
      signout () {
        this.$store.dispatch('signout');
        this.$router.push({ name: 'home' })
      },
      closeModalBadge () {
        this.resetNotificationsCount();
      }
    },
    watch:{
      $route (to, from){
        this.menuIsShown = false;
      }
    }
  }
</script>

<style scoped>
  .main-menu ul li.membre {
    display: inline-block;
  }

  .user-infos {
    width: 25%;
    max-width: 300px;
    float: right;
    background: #413491;
    position: relative;
    top: -25px;
    right: -25px;
    height: 103px;
    padding: 25px 10px 15px 15px ;
    color: white;
    font-family: 'blogger_sansbold';
    border-bottom: 3px dashed white;
    box-shadow: inset 35px 0px 45px rgba(0,0,0,0.2);
  }
  .user-infos .user-avatar {
    width: 60px;
    height: 60px;
    background: white;
    border-radius: 100px;
    border: 2px solid #888;
    overflow: hidden;
    display: inline-block;
    float: right;
    top: -5px;
    position: relative;
   }
  .user-infos .user-avatar:not(.caregiver) {
    padding: 10px;
  }
  .user-infos .user-avatar .avatar {
    transform: scale(0.4);
    top: -82px;
    left: -58px;
  }
  .user-infos .user-avatar.caregiver .avatar {
    transform: scale(1.2);
    top: -82px;
    left: -58px;
  }
  .user-infos p,
  .user-infos a {
    display: inline-block;
    color: white;
    font-family: 'blogger_sansbold';
    text-align: right;
    line-height: 18px;
    font-size: 14px;
    position: relative;
  }
  .user-infos a { display: block; with: 100%; text-align: right; margin:0;}

  .user-infos a, .logout a { color: #e3e039;}

  .main-menu .logout { margin-top: 25px;}
  .user-infos .user-notifs {
    display: inline-block;
    position: relative;
    float: left;
    font-size: 35px;
    color: white;
  }
  .user-infos .user-notifs:hover { opacity: 0,5; }
  .user-infos .user-notifs span {
    position: absolute;
    height: 25px;
    width: 25px;
    background: #de2128;
    border-radius: 30px;
    text-align: center;
    top: 15px;
    right: -15px;
    font-size: 14px;
    padding: 2px 0;
  }

  @media (max-width: 1020px) {
    .user-infos {  width: 45%; }
  }
  @media (max-width: 640px) {
    .user-infos { max-width: 150px; }
    .user-infos p { display: none; }

  }
  @media (max-width: 550px) {

    header {  padding: 20px 25px 20px 9px; }
    header .logo { width: 60px; overflow: hidden; }
    header .logo img { max-width: 180px; }
    .bt-mobile { margin: 0;   right: -12px; }
  }

</style>
